var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 42.5,
  y: 27.5,
  rx: 7.5,
  ry: 7.5,
  width: 15,
  height: 15,
  fill: "#7cbb42"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0.3",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.851063829787234s",
  repeatCount: "indefinite"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(72 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 42.5,
  y: 27.5,
  rx: 7.5,
  ry: 7.5,
  width: 15,
  height: 15,
  fill: "#ffcc07"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0.3",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.6382978723404255s",
  repeatCount: "indefinite"
})));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(144 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 42.5,
  y: 27.5,
  rx: 7.5,
  ry: 7.5,
  width: 15,
  height: 15,
  fill: "#f88f1f"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0.3",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.425531914893617s",
  repeatCount: "indefinite"
})));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(216 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 42.5,
  y: 27.5,
  rx: 7.5,
  ry: 7.5,
  width: 15,
  height: 15,
  fill: "#e22e0b"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0.3",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.2127659574468085s",
  repeatCount: "indefinite"
})));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(288 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 42.5,
  y: 27.5,
  rx: 7.5,
  ry: 7.5,
  width: 15,
  height: 15,
  fill: "#ae0006"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0.3",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
})));
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(241, 242, 243, 0)",
      display: "block"
    },
    width: "105px",
    height: "105px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.898c3e8cfc7064676d3eb37dae7ae14b.svg";
export { ForwardRef as ReactComponent };